import { useEffect, useState } from 'react';
import { ASSETS } from '@/lib/brand';

/**
 * Elegant boot loader — shows on first page load only.
 * Monogram fades in with a hairline gold divider drawing across, then dissolves.
 */
export default function PageLoader() {
  const [phase, setPhase] = useState('in'); // in -> hold -> out -> done

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('hold'), 350);
    const t2 = setTimeout(() => setPhase('out'), 1050);
    const t3 = setTimeout(() => setPhase('done'), 1700);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      data-testid="page-loader"
      aria-hidden="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#070B12] pointer-events-none"
      style={{
        opacity: phase === 'out' ? 0 : 1,
        transition: 'opacity 600ms cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <div className="flex flex-col items-center gap-6">
        <img
          src={ASSETS.monogramDark}
          alt=""
          className="h-16 w-16 object-contain rounded-sm ring-1 ring-[#B68A35]/40"
          style={{
            opacity: phase === 'in' ? 0 : 1,
            transform: phase === 'in' ? 'scale(0.94)' : 'scale(1)',
            transition: 'all 700ms cubic-bezier(0.2, 0.7, 0.2, 1)',
          }}
        />
        <div className="relative h-px w-40 overflow-hidden">
          <div
            className="absolute inset-y-0 left-0 bg-[#B68A35]"
            style={{
              width: phase === 'in' ? '0%' : '100%',
              transition: 'width 850ms cubic-bezier(0.4, 0, 0.2, 1) 150ms',
            }}
          />
        </div>
        <p
          className="text-[#D6B36A]/70 text-[0.65rem] tracking-[0.4em] uppercase font-light"
          style={{
            opacity: phase === 'in' ? 0 : 1,
            transition: 'opacity 600ms cubic-bezier(0.2, 0.7, 0.2, 1) 400ms',
          }}
        >
          Bowers Advisory Group
        </p>
      </div>
    </div>
  );
}
